import debug from "debug";
import plugin from '../../lib/plugin';

export const MODULE_NAME = 'app.core/modules/image-gallery';
export const ELEMENT_SELECTOR = '[data-image-gallery]';
const log = debug(MODULE_NAME);


export function exec() {
    const elements = $(ELEMENT_SELECTOR).toArray();
    if (!elements || !elements.length) { return; }
    const { ImageGalleryComponent } = require('./component');
    plugin('imageGallery', ImageGalleryComponent);
    $(elements).imageGallery();
};



// WEBPACK FOOTER //
// ./project/client/src/core/modules/image-gallery/index.js